import getThreadParentId from '@/redux/selectors/pieveSelectors/lib/getThreadParentId.js';

const getSubagentContextParentId = ({ threadMetaByIdValue, threadId }) => {
  const normalizedThreadId = String(threadId || '').trim();

  if (!normalizedThreadId) {
    return null;
  }

  return getThreadParentId(threadMetaByIdValue?.[normalizedThreadId] || null) || normalizedThreadId;
};

export default getSubagentContextParentId;
